export default {
  TABS: {
    INBOX: '@msg-label/msg-label-inbox',
    SENT: '@msg-label/msg-label-sent',
    TRASH: '@msg-label/msg-label-trash'
  }
};